import api from '../../plugins/api';

const getAdditionalServices = (params) => {
  return api.get('api/crm/additional-services/getAdditionalServices', params);
};

export default getAdditionalServices;
